import React , {useState} from "react";
import Header from "../header";
import Footer from "../footer";
import "./style.css"
import LeftSide from "../../components/LeftSide/LeftSide";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { Phone, whatsApp } from "../../assets/svgIcons";
import IconWithText from "../../components/iconWithText";
import PopUp from './../../components/popup/index';
import UseGeneral from "../../hooks/useGeneral";
import { useSelector } from "react-redux";
const DefaultLayout = ({ classessName, children, whats, phone }) => {
  const [openLeftSide , setLeftSide] = useState(false)
  const [openPopup, setOpenPopup] = useState(false);  
  const { language } = UseGeneral();
  const siteData = useSelector((state) => state?.site?.siteData);


  return (
    <div
      className={
        !classessName || !classessName?.length
          ? "defaultLayout"
          : "defaultLayout" + " " + classessName?.join()
      }
    >

      <div className="big_screen_header">
        <Header whats={whats} phone={phone} />
      </div>
      <div className="small_screen_header">
        <MobileHeader open={openLeftSide} setOpen={setLeftSide} />
      </div>
      {children}
      <Footer />

      <PopUp
        open={openPopup}
        setOpen={setOpenPopup}
        title={language == "ar" ? "تواصل معنا" : "Contact Us"}
      >
        <div className="rowDiv">
          <IconWithText
            onClick={() => window.open("tel:" + siteData?.mobile, "_blanck")}
            icon={Phone}
            text={language == "ar" ? "الخط الساخن" : "Hot Line"}
            className={"contact"}
          />
        </div>
        <div className="rowDiv">
          <IconWithText
            onClick={() =>
              window.open(
                "https://wa.me/" + siteData?.whats_number,
                "_blanck"
              )
            }
            icon={whatsApp}
            text={language == "ar" ? "واتساب" : "WhatsApp"}
            className={"contact"}
          />
        </div>
      </PopUp> 

      <LeftSide openPopup= {openPopup} setOpenPopup={setOpenPopup}  open={openLeftSide} setOpen={setLeftSide} />
      


    </div>
  );
};

export default DefaultLayout;
